import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from 'contexts/AuthContext';

export interface DeleteSubscriptionParams {
  workspaceSlug: string;
}

export const useDeleteSubscription = () => {
  const { authApi } = useAuth();
  const queryClient = useQueryClient();

  return useMutation<void, Error, DeleteSubscriptionParams>({
    mutationFn: async ({ workspaceSlug }) => {
      await authApi.delete(`/staff/workspace/${workspaceSlug}/subscriptions`);
    },
    onSuccess: (_, variables) => {
      // Invalidate subscription queries for this workspace
      queryClient.invalidateQueries({ queryKey: ['subscription', variables.workspaceSlug] });
    },
    onError: (error: Error) => {
      console.error('Error canceling subscription:', error);
    }
  });
};
